var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinner01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3399_2107)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#039855",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0456 6.28263C12.1681 5.90579 12.7012 5.90579 12.8236 6.28263L13.9499 9.74878C14.0046 9.91731 14.1617 10.0314 14.3389 10.0314H17.9834C18.3796 10.0314 18.5444 10.5384 18.2238 10.7713L15.2753 12.9135C15.132 13.0177 15.072 13.2023 15.1267 13.3708L16.253 16.837C16.3754 17.2138 15.9441 17.5272 15.6235 17.2943L12.6751 15.1521C12.5317 15.0479 12.3376 15.0479 12.1942 15.1521L9.24574 17.2943C8.92518 17.5272 8.49387 17.2138 8.61631 16.837L9.74253 13.3708C9.79729 13.2023 9.73731 13.0177 9.59395 12.9135L6.64546 10.7713C6.32491 10.5384 6.48965 10.0314 6.88588 10.0314H10.5304C10.7076 10.0314 10.8647 9.91731 10.9194 9.74878L12.0456 6.28263Z",
    fill: "#039855"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3399_2107"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinner01);
export default __webpack_public_path__ + "static/media/winner-01.a733e0a3563d29f825abf33b361d5d1d.svg";
export { ForwardRef as ReactComponent };